// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"79516071","453":"f2bc8ee6","705":"e356a435"}[chunkId] + ".chunk.js";
};